export const needsSmallFont = () => {
  return true;
};
